(function ($, root) {
  ("use strict");

  let thankYouPageURL = null;
  let paypalSpinner = document.querySelector(".paypal-loading-spinner");
  let paypalPayButton = document.querySelector("#card-field-submit-button");

  const LOG_ERROR = root.makeUrl({
    module: "eshop",
    manager: "payment",
    action: "onError",
  });

  /**
   * Centralized Error Logger
   */
  function logError(error, orderData = {}) {
    try {
      const data = {
        payload: error,
        paymentMethod: "PayPalAdvanced",
        orderId: orderData.internalInfo.orderId || null,
        paymentData: orderData.paymentData || null,
        message: typeof error === "string" ? error : error.message || JS_TRANSLATIONS.genericErrorMsg,
      };

      fetch(LOG_ERROR, {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
    } catch (e) {
      console.error("Error while logging original error", e);
    }
  }

  /**
   * Common fetch wrapper for JSON requests
   */
  async function jsonPost(url, body = undefined) {
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    };

    if (body !== undefined) {
      options.body = JSON.stringify(body);
    }

    const response = await fetch(url, options);
    return response.json();
  }

  /**
   * Trigger error event for UI
   */
  function triggerUiError(error) {
    root.jQuery(document).trigger("zg-error", [
      {
        message: `${root.JS_TRANSLATIONS["paypal.error.not.init"]}<br>${error}`,
      },
    ]);
  }

  /**
   * PayPal Button Configuration
   */
  if (root.paypaladvanced) {
    root.paypaladvanced
      .Buttons({
        style: {
          shape: "rect",
          layout: "vertical",
          color: "gold",
          label: "paypal",
          disableMaxWidth: true,
        },

        /**
         * CREATE ORDER
         */
        createOrder: createOrderCallback,

        /**
         * ON APPROVE
         */
        onApprove: onApproveCallback,

        /**
         * CANCELLATIONS
         */
        onCancel() {
          window.location.reload();
        },
        /**
         * ERROR
         */
        onError(err) {
          console.log("paypal error: ", err);
          logError(err);
        },
      })
      .render("#paypal-button-container");
  }

  // Render each field after checking for eligibility
  if (root.paypaladvanced && root.paypaladvanced.CardFields) {
    const cardField = root.paypaladvanced.CardFields({
      createOrder: createOrderCallback,
      onApprove: onApproveCallback,
      onError: (error) => {
        console.error("Error configuring Card Fields:", error);
        logError(error);
        triggerUiError(`${root.JS_TRANSLATIONS["paypal.error.card.fields"]}`);
      },
      onCancel: () => {
        console.log(root.JS_TRANSLATIONS["paypal.error.card.fields.cancel"]);
        triggerUiError(
          `${root.JS_TRANSLATIONS["paypal.error.card.fields.cancel"]}`,
        );
      },
      inputEvents: {
        onChange: (data) => {
          //Enable Card Payment Button when the payment data is filled and billing form is valid
          if (data.isFormValid) {
            paypalPayButton.removeAttribute("disabled");
            paypalPayButton.classList.remove("disabled");
          } else {
            paypalPayButton.setAttribute("disabled", true);
            paypalPayButton.classList.add("disabled");
          }
        },
      },
      style: {
        input: {
          "font-size": "16px",
          "font-family": "Work Sans,courier, monospace",
          "font-weight": "normal",
          color: "#303133",
          height: "45px",
        },
        ".invalid": { color: "#dc3545" },
      },
    });
    if (cardField.isEligible()) {
      paypalPayButton.classList.remove("hidden");

      const numberField = cardField.NumberField();
      numberField.render("#card-number-field-container");

      const cvvField = cardField.CVVField();
      cvvField.render("#card-cvv-field-container");

      const expiryField = cardField.ExpiryField();
      expiryField.render("#card-expiry-field-container");

      // Add click listener to submit button and call the submit function on the CardField component
      paypalPayButton.addEventListener("click", (e) => {
        e.preventDefault();
        paypalPayButton.disabled = true;

        cardField
          .submit()
          .then(() => {
            // Handle a successful payment
            // We redirect to the thank you page after the payment is successful in the approve callback
          })
          .catch((err) => {
            triggerUiError(err);
          });
      });
    }
  }

  async function createOrderCallback() {
    const paymentConfig = {
      module: "eshop",
      manager: "payment",
      action: "pay",
      pMet: "PayPalAdvanced",
    };

    const orderId = document.getElementById("order-id").value;

    if (orderId) {
      paymentConfig.oID = orderId;
    }

    const url = root.makeUrl(paymentConfig);

    try {
      paypalSpinner.classList.remove("hidden");

      const orderData = await jsonPost(url);

      if (orderData.paymentData.orderId) {
        paypalSpinner.classList.add("hidden");
        thankYouPageURL = orderData.internalInfo.thankYouPageUrl;
        return orderData.paymentData.orderId;
      }

      let errorDetail = '';

      if(orderData.errorDetail && orderData.errorDetail.legnth > 0){
        errorDetail = orderData.details[0];
      }
      const message = errorDetail
        ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
        : JSON.stringify(orderData);

      throw new Error(message);
    } catch (error) {
      console.error("Create order error:", error);
      logError(error);
      triggerUiError(error);
      paypalSpinner.classList.add("hidden");
    }
  }

  async function onApproveCallback(data, actions) {
    const captureConfig = {
      module: "eshop",
      manager: "payment",
      action: "capture",
    };

    const url = new URL(root.makeUrl(captureConfig));
    url.searchParams.set("paymentMethod", "PayPalAdvanced");
    url.searchParams.set("orderId", data.orderID);

    try {
      paypalSpinner.classList.remove("hidden");

      const orderData = await jsonPost(url.href);
      let errorDetail = '';

      if(orderData.errorDetail && orderData.errorDetail.legnth > 0){
        errorDetail = orderData.details[0];
      }

      // (1) Recoverable instrument declined
      if (errorDetail.issue === "INSTRUMENT_DECLINED") {
        return actions.restart();
      }

      // (2) Unrecoverable errors
      if (errorDetail) {
        throw new Error(`${errorDetail.description} (${orderData.debug_id})`);
      }

      // (3) Success — redirect to thank-you
      if (thankYouPageURL) {
        window.location.replace(thankYouPageURL); // Manual redirect
      }
    } catch (error) {
      console.error("Approval error:", error);
      logError(error);
      triggerUiError(error);
      paypalSpinner.classList.add("hidden");
    }
  }
})(window.jQuery, window);